import Contact from "../components/contact/contact"
import Footer from "../components/footer/footer"
import BlockChain from "../components/home/blockChain"
import Main from "../components/home/main/main"
import OnlyTraum from "../components/home/onlyTraum/onlyTraum"
import Partner from "../components/home/partner/partner"
import Trading from "../components/home/trading"

const Home = () => {
  return(
    <>
      <Main />
      <BlockChain />
      <Trading />
      <OnlyTraum />
      <Contact />
      <Partner />
      <Footer />
    </>
  )
}

export default Home